export enum EnumProcessoStatus {
    AGUARDANDO = 0,
    PRODUCAO = 1,
    FINALIZADO = 2,
    CANCELADO = 3,
}